export default __webpack_public_path__ + "static/media/booth_image@3x.9ffe25fe.jpg";